import React from "react";

const VideoCard = ({ video, index, onVideoClick }) => {
  const handleClick = () => {
    if (onVideoClick) {
      onVideoClick(video);
    }
  };

  return (
    <div
      className="flex flex-col gap-2 items-start shrink-0 w-[430px] group animate-fadeIn cursor-pointer"
      style={{
        animationDelay: `${index * 50}ms`,
        animationFillMode: "forwards",
        opacity: 0,
      }}
    >
      {/* Video Thumbnail Card */}
      <div
        onClick={handleClick}
        className="flex flex-col gap-7 items-end p-5 rounded-[24px] shrink-0 w-full h-[216px] relative overflow-hidden transition-transform group-hover:scale-[1.02]"
      >
        {/* Solid blue gradient background — uniform across all video cards */}
        <div
          className="absolute inset-0"
          style={{
            background: "linear-gradient(135deg, #0E48B2 0%, #0C3B91 100%)",
          }}
        />

        {/* Content Layer */}
        <div className="relative z-10 flex flex-col gap-7 items-end w-full h-full">
          {/* Category Label */}
          <p
            className="text-base font-medium leading-5 tracking-[-0.16px] text-white w-full"
            style={{ fontFamily: "Satoshi, sans-serif" }}
          >
            {video.category}
          </p>

          {/* Video Title */}
          <p
            className="text-[32px] font-medium leading-[38px] tracking-[-0.32px] text-white text-center w-full flex-1 flex items-center justify-center drop-shadow-lg"
            style={{ fontFamily: "Satoshi, sans-serif" }}
          >
            {video.title}
          </p>

          {/* Duration Badge — only rendered when there's a duration to show */}
          {video.duration && (
            <div className="bg-[rgba(0,0,0,0.6)] flex items-center justify-center px-2 py-0.5 rounded-[99px]">
              <p
                className="text-xs font-normal leading-5 text-white"
                style={{ fontFamily: "Inter, sans-serif" }}
              >
                {video.duration}
              </p>
            </div>
          )}
        </div>

        {/* Play Icon Overlay on Hover */}
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity z-20">
          <div className="w-16 h-16 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center transform group-hover:scale-110 transition-transform">
            <svg
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="white"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M8 5.14v14l11-7-11-7z" />
            </svg>
          </div>
        </div>
      </div>

      {/* Video Info Below Card */}
      <div className="flex flex-col items-start px-3">
        <p
          className="text-xl font-medium leading-7 text-[rgba(0,0,0,0.85)]"
          style={{ fontFamily: "Inter, sans-serif" }}
        >
          {video.sectionName}
        </p>
        <p
          className="text-base font-normal leading-[25px] text-[rgba(0,0,0,0.45)] line-clamp-2"
          style={{ fontFamily: "Inter, sans-serif" }}
        >
          {video.shortDescription || video.description}
        </p>
      </div>
    </div>
  );
};

export default VideoCard;
